import { render, staticRenderFns } from "./TableRecordView.vue?vue&type=template&id=24f0bd58&"
import script from "./TableRecordView.vue?vue&type=script&lang=js&"
export * from "./TableRecordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports